/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const BATTERY_CHARGE_MIN = 0;
export const BATTERY_CHARGE_MAX = 100;
export const BATTERY_CHARGE_STEP = 1;
